import React, { useState, useRef } from 'react';
import { IPatientSearchBar, IPatientSearchResult } from '../../interface/PatientInterface';
import { endpoints } from '../../utils/URL';
import axios from 'axios';
import { useOutsideAlerter } from './OutsideClick';

const PatientSearch = ({ callback, inputStyle }: IPatientSearchBar) => {
  const [patientSearchResult, setPatientSearchResult] = useState<IPatientSearchResult[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  let timer: NodeJS.Timeout;
  const axiosInstance = axios.create();

  const hideSearchResult = (event: any) => {
    setShowSearch(false);
  };

  const inputFocus = () => {
    setShowSearch(true);
  };

  /*To handle when we clck outside the search */

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, hideSearchResult);

  /* end click outside */

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputSearch = event.target.value;
    setSearchTerm(inputSearch);
    // if (inputSearch.length < 3) {
    //   return;
    // }
    // searchPatient(inputSearch);
  };
  const clearTimer = () => {
    clearTimeout(timer);
  };

  const startTimer = (event: any) => {
    clearTimeout(timer);
    let searchTerm = event.target.value;
    timer = setTimeout(() => searchPatient(searchTerm), 1000);
  };

  const searchPatient = async (searchTerm: string) => {
    if (searchTerm.length < 3) {
      return;
    }

    //show loading
    const loading = {
      patientId: 0,
      patientName: 'Loading...',
      phoneNumber: '',
    };
    const loadingArray = [loading];
    setPatientSearchResult(loadingArray);
    setShowSearch(true);

    const url = `${endpoints.patients.getByName}/${searchTerm}`;

    try {
      const response = await axiosInstance.get(url); //use a new instance of axios to avoid showing full screen loading
      setPatientSearchResult(response.data);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const selectPatient = (selectedPatient: IPatientSearchResult) => {
    setSearchTerm(selectedPatient.patientName);
    setShowSearch(false);

    //callback set, call the callback passing the selected patient data
    if (callback) {
      callback(selectedPatient);
    }
  };

  return (
    <div className='form-group ' ref={wrapperRef} onFocus={inputFocus}>
      {/* onFocus={toggleSearchResult} onBlur={toggleSearchResult}> */}
      <span className='bi bi-search search-icon'></span>
      <input
        type='text'
        className={inputStyle ? 'form-control ps-5 pe-4 ' + inputStyle : 'form-control ps-5 pe-4'}
        placeholder='Search. Start typing name or phone to select'
        onChange={handleChange}
        value={searchTerm}
        onKeyUp={startTimer}
        onKeyDown={clearTimer}
      />
      {showSearch && patientSearchResult.length > 0 ? (
        <div className='search-result-panel'>
          <ul style={{ marginLeft: '-30px', backgroundColor: 'white' }}>
            {patientSearchResult.map((patient) => (
              <li
                key={patient.patientId}
                className='search-result'
                onClick={() => selectPatient(patient)}
              >
                {patient.patientName} - {patient.phoneNumber}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PatientSearch;
